import Vue from 'vue';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import moment from 'moment';

Vue.filter('phone', (value) => {
  if (!value) {
    return '';
  }
  const phoneNumberParsed = parsePhoneNumberFromString(value);
  return phoneNumberParsed && phoneNumberParsed.formatInternational();
});

Vue.filter('date', (value, format) => moment(value).format(format));
